import(/* webpackMode: "eager" */ "/app/packages/libs/fo/api/mindbox/src/lib/MindboxPageView.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/api/mindbox/src/lib/scriptMindbox.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/feature/product/catalog/base/src/lib/FeatureProductCatalogBase.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/feature/product/catalog/base/src/util/parseAsObject.ts");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/article/layout/page/src/lib/UiArticleLayoutPage.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/kit/banner/hero/src/lib/UiKitBannerHero.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/mod/footnote/base/src/lib/UiModFootnoteBase.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/product/layout/catalog/src/lib/UiProductLayoutCatalog.tsx");
